/**
 * @generated SignedSource<<e9f96ad81f4cf03196ce7a52af95033e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchInput_ContentUsageFragment$data = {
  readonly content: {
    readonly name: string | null;
  };
  readonly id: string;
  readonly " $fragmentType": "BrainSearchInput_ContentUsageFragment";
};
export type BrainSearchInput_ContentUsageFragment$key = {
  readonly " $data"?: BrainSearchInput_ContentUsageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchInput_ContentUsageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchInput_ContentUsageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "9172b8d3a1f57a8a905a283557be2e2d";

export default node;
